import { useLocation } from 'react-router-dom';
import { isNil } from 'lodash-es';
import { parse } from 'query-string';
import dayjs from '@/services/tools/dayjs';
import { DEFAULT_OFFSET, DEFAULT_PER_PAGE_COUNT, LONG_DATE_FORMAT } from '@/services/constants';
import { LandingCheckoutScope, LandingCheckoutStatusEnum } from '@dev/ee-api/ee-api-models';
import { GetCheckoutsParams } from '@/services/ElasticApi';

export const useCheckoutParamsFromUrl = (): GetCheckoutsParams => {
    const location = useLocation();

    const query = parse(location.search, { parseBooleans: true });

    const limit = query?.perPage ? +query.perPage : DEFAULT_PER_PAGE_COUNT;
    const offset = query?.page ? +query.page * limit - limit : DEFAULT_OFFSET;
    const search = isNil(query?.search) ? null : (query?.search as string);
    const page = Number(query?.page) || 1;
    const isDraftsList = location.pathname.includes('draft');
    const statusList = (isDraftsList ? [LandingCheckoutStatusEnum.Draft] : isNil(query?.statuses) ? [LandingCheckoutStatusEnum.Published, LandingCheckoutStatusEnum.Unpublished] : [...query.statuses as string[]]) as LandingCheckoutStatusEnum[];
    const from = isNil(query?.from) ? null : (dayjs(query?.from as string).format(LONG_DATE_FORMAT));
    const to = isNil(query?.to) ? null : (dayjs(query?.to as string).format(LONG_DATE_FORMAT));

    if (GALLERY_CREATOR === 'true' && !isDraftsList) {
        return {
            page,
            limit,
            search,
            statusList: [LandingCheckoutStatusEnum.Draft],
            offset,
            from,
            to,
            scope: LandingCheckoutScope.Public
        };
    }

    return {
        page,
        limit,
        search,
        statusList,
        offset,
        from,
        to
    };
};
